import { useEffect, useState } from 'react';
import * as logistaService from '@/services/logistaService';

const discountTypes = [
  { value: 'percentage', label: 'Percentagem (%)' },
  { value: 'fixed', label: 'Valor fixo (€)' },
  { value: 'free_item', label: 'Item grátis' },
];

const empty = {
  title: '',
  description: '',
  discountType: 'percentage',
  discountValue: '',
  coinCost: '',
  stock: '',
  startsAt: '',
  expiresAt: '',
};

function OfertaModal({ oferta, onClose, onSave }) {
  const [form, setForm] = useState(oferta || empty);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await onSave(form);
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao guardar oferta.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
      <div className="w-full max-w-lg overflow-y-auto rounded-2xl bg-surface p-6 shadow-2xl max-h-[90vh]">
        <div className="mb-5 flex items-center justify-between">
          <h2 className="font-serif text-xl font-bold text-fg">{oferta ? 'Editar oferta' : 'Nova oferta'}</h2>
          <button type="button" onClick={onClose} className="text-muted hover:text-muted text-xl">✕</button>
        </div>

        <form onSubmit={submit} className="grid gap-3">
          <div>
            <label className="mb-1 block text-sm font-semibold text-fg">Título *</label>
            <input
              required
              value={form.title}
              onChange={(e) => set('title', e.target.value)}
              className="w-full rounded-xl border border-edge bg-background px-4 py-2.5 text-sm outline-none focus:border-accent"
              placeholder="Ex: 10% de desconto em tudo"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-semibold text-fg">Descrição</label>
            <textarea
              rows={2}
              value={form.description}
              onChange={(e) => set('description', e.target.value)}
              className="w-full resize-none rounded-xl border border-edge bg-background px-4 py-2.5 text-sm outline-none focus:border-accent"
              placeholder="Detalhes adicionais..."
            />
          </div>

          <div className="grid gap-3 sm:grid-cols-2">
            <div>
              <label className="mb-1 block text-sm font-semibold text-fg">Tipo de desconto *</label>
              <select
                value={form.discountType}
                onChange={(e) => set('discountType', e.target.value)}
                className="w-full rounded-xl border border-edge bg-background px-4 py-2.5 text-sm outline-none focus:border-accent"
              >
                {discountTypes.map((d) => <option key={d.value} value={d.value}>{d.label}</option>)}
              </select>
            </div>
            {form.discountType !== 'free_item' && (
              <div>
                <label className="mb-1 block text-sm font-semibold text-fg">
                  Valor {form.discountType === 'percentage' ? '(%)' : '(€)'}
                </label>
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  value={form.discountValue}
                  onChange={(e) => set('discountValue', e.target.value)}
                  className="w-full rounded-xl border border-edge bg-background px-4 py-2.5 text-sm outline-none focus:border-accent"
                />
              </div>
            )}
          </div>

          <div className="grid gap-3 sm:grid-cols-2">
            <div>
              <label className="mb-1 block text-sm font-semibold text-fg">Custo em moedas *</label>
              <input
                type="number"
                required
                min="0"
                value={form.coinCost}
                onChange={(e) => set('coinCost', e.target.value)}
                className="w-full rounded-xl border border-edge bg-background px-4 py-2.5 text-sm outline-none focus:border-accent"
                placeholder="Ex: 100"
              />
              <p className="mt-0.5 text-xs text-muted">Moedas que o jogador gasta para resgatar</p>
            </div>
            <div>
              <label className="mb-1 block text-sm font-semibold text-fg">Stock (-1 = ilimitado)</label>
              <input
                type="number"
                min="-1"
                value={form.stock}
                onChange={(e) => set('stock', e.target.value)}
                className="w-full rounded-xl border border-edge bg-background px-4 py-2.5 text-sm outline-none focus:border-accent"
                placeholder="-1"
              />
            </div>
          </div>

          <div className="grid gap-3 sm:grid-cols-2">
            <div>
              <label className="mb-1 block text-sm font-semibold text-fg">Data início</label>
              <input
                type="date"
                value={form.startsAt ? form.startsAt.slice(0, 10) : ''}
                onChange={(e) => set('startsAt', e.target.value)}
                className="w-full rounded-xl border border-edge bg-background px-4 py-2.5 text-sm outline-none focus:border-accent"
              />
            </div>
            <div>
              <label className="mb-1 block text-sm font-semibold text-fg">Data fim</label>
              <input
                type="date"
                value={form.expiresAt ? form.expiresAt.slice(0, 10) : ''}
                onChange={(e) => set('expiresAt', e.target.value)}
                className="w-full rounded-xl border border-edge bg-background px-4 py-2.5 text-sm outline-none focus:border-accent"
              />
            </div>
          </div>

          {error && <p className="rounded-xl bg-red-50 px-4 py-2 text-sm font-semibold text-red-600">{error}</p>}

          <div className="mt-1 flex justify-end gap-3">
            <button type="button" onClick={onClose} className="rounded-xl border border-edge px-4 py-2.5 text-sm font-semibold text-muted hover:bg-background">
              Cancelar
            </button>
            <button type="submit" disabled={saving} className="rounded-xl bg-accent px-5 py-2.5 text-sm font-bold text-white hover:bg-accent disabled:opacity-60">
              {saving ? 'A guardar...' : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function statusBadge(oferta) {
  const now = new Date();
  if (!oferta.isActive) return <span className="rounded-full bg-surfaceAlt px-2 py-0.5 text-xs font-semibold text-muted">Inativa</span>;
  if (oferta.expiresAt && new Date(oferta.expiresAt) < now) return <span className="rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-600">Expirada</span>;
  if (oferta.stock === 0) return <span className="rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-600">Sem stock</span>;
  return <span className="rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-semibold text-emerald-600">Ativa</span>;
}

export default function LogistaOfertasPage() {
  const [ofertas, setOfertas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null); // null | 'new' | ofertaObj

  const load = async () => {
    try {
      const r = await logistaService.getOfertas();
      setOfertas(r.data.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleSave = async (form) => {
    if (modal === 'new') {
      await logistaService.createOferta(form);
    } else {
      await logistaService.updateOferta(modal.id, form);
    }
    await load();
  };

  const toggleActive = async (oferta) => {
    await logistaService.updateOferta(oferta.id, { isActive: !oferta.isActive });
    setOfertas((prev) => prev.map((o) => o.id === oferta.id ? { ...o, isActive: !o.isActive } : o));
  };

  if (loading) {
    return <div className="flex h-64 items-center justify-center"><div className="h-8 w-8 animate-spin rounded-full border-4 border-accent border-t-transparent" /></div>;
  }

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-serif text-2xl font-black text-fg">Ofertas</h1>
          <p className="text-sm text-muted">{ofertas.length} oferta{ofertas.length !== 1 ? 's' : ''} criada{ofertas.length !== 1 ? 's' : ''}</p>
        </div>
        <button
          onClick={() => setModal('new')}
          className="rounded-xl bg-accent px-4 py-2.5 text-sm font-bold text-white hover:bg-accent"
        >
          + Nova oferta
        </button>
      </div>

      {ofertas.length === 0 ? (
        <div className="rounded-2xl border-2 border-dashed border-edge bg-surface py-16 text-center">
          <p className="text-4xl">🎁</p>
          <p className="mt-2 font-bold text-muted">Ainda não tens ofertas</p>
          <p className="text-sm text-muted">Cria a tua primeira oferta para atrair jogadores</p>
          <button onClick={() => setModal('new')} className="mt-4 rounded-xl bg-accent px-5 py-2.5 text-sm font-bold text-white">
            Criar oferta
          </button>
        </div>
      ) : (
        <div className="grid gap-3">
          {ofertas.map((oferta) => (
            <div key={oferta.id} className="flex items-center gap-4 rounded-2xl border border-edge bg-surface p-4 shadow-sm">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="truncate font-bold text-fg">{oferta.title}</p>
                  {statusBadge(oferta)}
                </div>
                <p className="mt-0.5 truncate text-sm text-muted">{oferta.description}</p>
                <div className="mt-1 flex flex-wrap gap-3 text-xs text-muted">
                  <span>💰 {oferta.coinCost} moedas</span>
                  {oferta.discountType === 'percentage' && <span>🏷️ {oferta.discountValue}% desc.</span>}
                  {oferta.discountType === 'fixed' && <span>🏷️ {oferta.discountValue}€ desc.</span>}
                  {oferta.discountType === 'free_item' && <span>🏷️ Item grátis</span>}
                  {oferta.stock >= 0 && <span>📦 {oferta.stock} em stock</span>}
                  {oferta.expiresAt && <span>📅 até {new Date(oferta.expiresAt).toLocaleDateString('pt-PT')}</span>}
                </div>
              </div>
              <div className="flex shrink-0 items-center gap-2">
                <button
                  onClick={() => toggleActive(oferta)}
                  className={`rounded-xl px-3 py-1.5 text-xs font-bold transition ${oferta.isActive ? 'bg-surfaceAlt text-muted hover:bg-surfaceAlt' : 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200'}`}
                >
                  {oferta.isActive ? 'Desativar' : 'Ativar'}
                </button>
                <button
                  onClick={() => setModal(oferta)}
                  className="rounded-xl border border-accent/30 bg-accent/5 px-3 py-1.5 text-xs font-bold text-accent hover:bg-accent/10"
                >
                  Editar
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {modal && (
        <OfertaModal
          oferta={modal === 'new' ? null : modal}
          onClose={() => setModal(null)}
          onSave={handleSave}
        />
      )}
    </div>
  );
}
